module.exports = __webpack_public_path__ + "img/dog-02-cycle.7b29e648.png";